export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  cacheLocation: 'localstorage' as const,
  useRefreshTokens: true,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope: 'openid profile email read:admin write:admin manage:feedback',
  },
};

export function createLoginOptions() {
  return {
    appState: {
      returnTo:
        window.location.pathname +
        window.location.search +
        window.location.hash,
    },
    authorizationParams: { connection: 'google-oauth2' },
  };
}
